import React from "react";
import { Backdrop } from "@mui/material";
import LoaderGif from "../assets/images/Loader_recolored_transparent.gif";

const Loader = () => (
  <Backdrop
    open={true} // Change to `false` to hide the backdrop
    sx={(theme) => ({
      color: "#fff", // Text color inside the backdrop
      backgroundColor: "rgb(65 63 63 / 70%)", // Semi-transparent background color
      zIndex: theme.zIndex.drawer + 1, // Ensure it appears above other components
      display: "flex", // Use flexbox to center content
      justifyContent: "center", // Center horizontally
      alignItems: "center", // Center vertically
    })}
  >
    <img src={LoaderGif} height="80" alt="loader-gif" width="80" />
  </Backdrop>
);

export default Loader;
